import React, { memo } from "react";
import { useFormContext } from "react-hook-form";
import { Layout, Flex, InputRadioField, SpacingBox } from "../../../components";
import { formControls } from "../constants/forms";
import FieldTooltip from "./FieldTooltip";
import { tooltips } from "../constants/tooltips";
import "../styles/ClientTypeField.css";

const ClientTypeField = ({ isTenant }) => {
    const { clientType } = formControls;
    const { register, setValue } = useFormContext();
    return (
        <div className="client-type-field">
            <label
                id="clientType"
                htmlFor={clientType.key}
                className="form-control__label"
            >
                <Layout align="center">
                    {clientType.label}
                    <FieldTooltip content={tooltips.clientType} />
                </Layout>
            </label>
            <Layout>
                <Flex flex={1}>
                    <InputRadioField
                        id={clientType.owner.key}
                        label={clientType.owner.text}
                        value={clientType.owner.key}
                        {...register(clientType.key)}
                        setValue={setValue}
                        aria-labelledby="clientType"
                    />
                </Flex>
                <Flex flex={1}>
                    <InputRadioField
                        id={clientType.roomer.key}
                        label={clientType.roomer.text}
                        value={clientType.roomer.key}
                        {...register(clientType.key)}
                        setValue={setValue}
                        aria-labelledby="clientType"
                    />
                </Flex>
            </Layout>
            {!isTenant && (
                <SpacingBox mt="20">
                    <hr />
                </SpacingBox>
            )}
            {isTenant && (
                <div className="client-type-field__tenant-message">
                    Recuerda que solo puedes proteger tus cosas
                </div>
            )}
        </div>
    );
};

export default memo(ClientTypeField);
